module.exports = __webpack_public_path__ + "img/thumb_27.65de21e4.jpg";